import { GitBranch01Icon } from '@langchain/untitled-ui-icons';

import { cn } from '@/utils/tailwind';

const ProjectIcon = (props: { className?: string }) => {
  return <GitBranch01Icon className={cn('size-4', props.className)} />;
};

export default ProjectIcon;
